export default __webpack_public_path__ + "static/media/index-banner2.0cf259cb.jpg";